import React from 'react';
import Card from './components/Card';

const App = () => {
  
  return (
    <>

      <Card />

    </>
  );

}

export default App;
